import { useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const useSingleFamilyCostsAndFees = ({ listingAlias, enabled }: { listingAlias: string; enabled: boolean }) => {
  return useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get(
    {
      listingAlias,
    },
    {
      enabled,
      meta: {
        context: {
          api: 'rental-manager',
          details: 'useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get',
        },
        tags: ['users-properties-fees-singleFamily-get'],
      },
    },
  );
};

export const getSingleFamilyCostsAndFeesKey = (params: { listingAlias: string }): ReadonlyArray<unknown> =>
  useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get.getKey(params);
